import React from 'react';
import { isMobile } from 'react-device-detect';
import { toast, Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import { colors } from 'ui-kit/theme/colors';

import ErrorAlertIcon from '../../assets/error_alert_icon.svg';
import InfoAlertIcon from '../../assets/info_alert_icon.svg';
import SuccessAlertIcon from '../../assets/success_alert_icon.svg';
import AlertIconWithGradient from './components/AlertIconWithGradient';
import AlertWithProgressBar from './components/AlertWithProgressBar';

const toastConfig = {
  duration: 8000,
  position: 'top-right' as const,
  style: {
    background: '#282828',
    color: '#FFFFFF',
  },
};

export const successAlert = (
  title: string = 'Success',
  description?: string
): void => {
  toast.custom(
    (t) => (
      <AlertWithProgressBar
        key={t.id}
        type="success"
        icon={
          <AlertIconWithGradient
            icon={<img src={SuccessAlertIcon} alt="success" style={{ width: 32, height: 32 }} />}
            gradientColor="#ffffff1a"
            type="success"
          />
        }
        title={title}
        description={description}
        progressColor={colors.success}
        duration={toastConfig.duration}
      />
    ),
    { ...toastConfig }
  );
};

export const errorAlert = (
  title: string = 'Error',
  description?: string
): void => {
  toast.custom(
    (t) => (
      <AlertWithProgressBar
        key={t.id}
        type="error"
        icon={
          <AlertIconWithGradient
            icon={<img src={ErrorAlertIcon} alt="error" style={{ width: 32, height: 32 }} />}
            gradientColor="#ffffff1a"
          />
        }
        title={title}
        description={description}
        progressColor={colors.error}
        duration={toastConfig.duration}
      />
    ),
    { ...toastConfig }
  );
};

export const infoAlert = (
  title: string = 'Info',
  description?: string
): void => {
  toast.custom(
    (t) => (
      <AlertWithProgressBar
        key={t.id}
        type="info"
        icon={
          <AlertIconWithGradient
            icon={<img src={InfoAlertIcon} alt="info" style={{ width: 24, height: 24 }} />}
            gradientColor="255,212,38"
            type="info"
          />
        }
        title={title}
        description={description}
        progressColor="#FFD426"
        duration={toastConfig.duration}
      />
    ),
    { ...toastConfig }
  );
};


export const AlertProvider = (): JSX.Element => {
  return <StyledToaster containerStyle={{ marginTop: isMobile ? 60 : 88 }} />;
};

const StyledToaster = styled(Toaster)`
  .toast {
    background: #282828;
    color: #fff;
    border-radius: 8px;
    padding: 14px 16px;
    min-width: 343px;
    max-width: 400px;
    width: 100%;
    box-shadow:
      0 8px 10px 0 rgba(0,0,0,0.20),
      0 6px 30px 0 rgba(0,0,0,0.12),
      0 16px 24px 0 rgba(0,0,0,0.14);
    display: flex;
    align-items: flex-start;
    gap: 16px;
    position: relative;
    overflow: hidden;
  }
`;